import { render, staticRenderFns } from "./OrderShipping.vue?vue&type=template&id=0e6df12a&scoped=true"
import script from "./OrderShipping.vue?vue&type=script&lang=js"
export * from "./OrderShipping.vue?vue&type=script&lang=js"
import style0 from "./OrderShipping.vue?vue&type=style&index=0&id=0e6df12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6df12a",
  null
  
)

export default component.exports